import Button from "@/components/atom/Button";
import Divider from "@/components/atom/Divider";
import Badge from "@/components/sub-atom/Badge";
import currency from "@/functions/currency";
import { cn } from "@/lib/utils";
import { ChevronUpSvg, LoadingSvg } from "@/public/svg";
import { CheckCheckIcon, XIcon } from "lucide-react";
import { useMemo, useState } from "react";

export default function HistoryWithdraw({ datas = [], getHistoryWithdraw }) {
  const [isSlice, setIsSlice] = useState(50);
  const [status, setStatus] = useState("");
  const isdatas = useMemo(() => {
    return datas.slice(0, isSlice);
  }, [datas, datas?.length, isSlice, status]);

  return (
    <div className=" bg-shadesGON-50 shadow-normalGON rounded-2xl ">
      <div className="flex flex-col gap-3 xs:gap-6 p-4 xs:p-8">
        <div className="flex flex-col gap-2 border-b border-b-greyscaleGON-200 pb-4">
          <p className="subheading-semiBold text-greyscaleGON-700">
            History Penarikan
          </p>
          <p className="p2-regular sm:p1-regular text-greyscaleGON-400">
            Menampilkan history Penarikan
          </p>
        </div>
        <div className="flex flex-row items-center gap-2">
          {[
            { value: "", title: "All" },
            { value: "PENDING", title: "Pending" },
            { value: "SUCCEED", title: "Success" },
            { value: "FAILED", title: "Failed" }
          ]?.map((a, b) => {
            return (
              <button
                key={b}
                onClick={() => {
                  setStatus(a?.value);
                  getHistoryWithdraw({ status: a.value });
                }}
              >
                <p
                  className={cn(
                    "px-4 py-2 border text-xs rounded-md hover:text-primaryGON-400/90",
                    a?.value == status
                      ? "border-primaryGON-200 text-primaryGON-400"
                      : "border-border text-black"
                  )}
                >
                  {a?.title}
                </p>
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col">
        {isdatas?.map((item, index) => {
          const isDate = item?.date?.split(" ");
          return (
            <div key={index} className="md:border-b-0 border-b pb-2 mb-2 flex">
              <div className="flex flex-row items-start justify-between w-full px-4 xs:px-8 ">
                <div className="flex items-start gap-3 w-full">
                  <p className="text-button-medium text-greyscaleGON-700">
                    {index + 1}.
                  </p>
                  <div className="flex flex-col gap-1">
                    <p className="text-button-medium text-greyscaleGON-700">
                      {item?.created_at}
                    </p>
                    <p className="p3-medium text-greyscaleGON-400">
                      {item?.account_number} - {item?.bank_name}
                    </p>
                    <p className="text-button-small text-greyscaleGON-600">
                      {item?.account_name}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 w-full justify-end">
                  {item.status_withdrawal == "PENDING" ? (
                    <div className="p-2 bg-primaryGON-50 rounded-full">
                      <LoadingSvg className="h-4 w-4 text-primaryGON-600" />
                    </div>
                  ) : item.status_withdrawal == "FAILED" ? (
                    <div className="p-2 bg-errorGON-50 rounded-full">
                      <XIcon className="h-4 w-4 text-errorGON-600" />
                    </div>
                  ) : (
                    <div className="p-2 bg-successGON-50 rounded-full">
                      <CheckCheckIcon className="h-4 w-4 text-successGON-600" />
                    </div>
                  )}
                  <p className="p1-medium text-greyscaleGON-500">
                    {currency(item?.withdrawal_amount ?? 0)}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
        {isSlice < datas.length && (
          <div>
            <Button
              label={"Lihat lainnya"}
              variants="outline"
              onClick={() => setIsSlice((old) => old + 5)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
